import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { ActiveLanguageGuard, LanguageGuard } from '@teamfoster/sdk/language-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';

import { ActionBarsGuard } from './action-bars/guards';
import { ResetTopbarGuard } from './core/guards/reset-topbar.guard';
import { InitCartGuard } from './shop';
import { InitCustomerTokenGuard } from './shop/guards/init-customer-token.guard';
import { NewsletterPopupSettingsGuard } from './newsletters/guards/newsletterpopup.guard';
import { ThemesGuard } from './themes/guards';
import { CustomerGuard } from './shop/guards/customer.guard';
import { SocialChannelsGuard } from './social-media/guards';
import { ActiveStorefrontGuard } from './storefronts/guards';
import { FaqGuard } from './faq/guards';

const appGuards = [
  CookieSettingsGuard,
  DictionaryGuard,
  ActionBarsGuard,
  MenuGuard,
  ResetTopbarGuard,
  InitCustomerTokenGuard,
  InitCartGuard,
  NewsletterPopupSettingsGuard,
  ThemesGuard,
  CustomerGuard,
  SocialChannelsGuard,
];

export const routes: Routes = [
  {
    path: '',
    canActivate: [ActiveStorefrontGuard, LanguageGuard, ActiveLanguageGuard], // Shop guard
    children: [
      {
        path: 'discount/:discountCode',
        canActivate: [...appGuards],
        pathMatch: 'full',
        loadChildren: () => import('./cart/cart.routes').then(m => m.routes),
      },
      {
        path: 'cart',
        loadChildren: () => import('./cart/cart.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'styleguide',
        loadChildren: () => import('./style-guide/style-guide.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'account',
        // pathMatch: 'full',
        loadChildren: () => import('./account/account.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: '404',
        loadComponent: () => import('./404.component').then(m => m.NotFoundComponent),
        canActivate: [...appGuards],
      },
      {
        path: '500',
        loadComponent: () => import('./404.component').then(m => m.NotFoundComponent),
        canActivate: [...appGuards],
      },
      {
        path: 'products',
        loadChildren: () => import('./catalog/catalog.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: 'collections',
        loadChildren: () => import('./catalog/catalog.routes').then(m => m.routes),
        canActivate: [...appGuards, FaqGuard],
      },
      {
        path: 'page',
        loadChildren: () => import('./content/content.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: '',
        loadChildren: () => import('./landing-page/landing-page.routes').then(m => m.routes),
        canActivate: [...appGuards],
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/404',
      },
    ],
  },
];
